import SearchBar from '@/components/common/search-bar';

interface TablePageSearchBarProps {
  search: string;
  setSearch: (search: string) => void;
  label?: string;
}

function TablePageSearchBar({ search, setSearch, label }: TablePageSearchBarProps) {
  return (
    <div className="flex items-center gap-2">
      {label && <div className="text-sm">{label}</div>}
      <SearchBar className="xxl:w-[300px] w-[150px]" search={search} setSearch={setSearch} />
    </div>
  );
}

export default TablePageSearchBar;
